import React from 'react';
interface AuthButtonProps {
  onClick: () => void;
  className?: string;
  /** Full-width block (mobile drawer) vs compact pill (header). */
  block?: boolean;
}

/**
 * Log in / Sign up — present, but deliberately secondary.
 *
 * The page's real call to action is the conversation, so this sits back as a
 * pale, frosted pill: a barely-there indigo→purple tint in the fill, a
 * hairline gradient border that drifts very slowly (the same material as
 * Ask AI, at a whisper), and indigo text. Hover brings the tint and border
 * up a step so it still reads as clickable.
 */
export function AuthButton({
  onClick,
  className = '',
  block = false
}: AuthButtonProps) {
  return <button onClick={onClick} className={`group/auth relative isolate inline-flex p-px ${block ? 'w-full rounded-xl' : 'rounded-full'} focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-indigo/30 focus-visible:ring-offset-2 ${className}`} data-id="element-79" data-mp="tghkkuk2dxjr">
      {/* Hairline gradient border, slowly drifting. */}
      <span aria-hidden className={`ask-ai-drift absolute inset-0 -z-10 ${block ? 'rounded-xl' : 'rounded-full'} bg-gradient-to-r from-primary-indigo/25 via-ai-purple/35 to-primary-indigo/25 bg-[length:300%_100%] opacity-80 group-hover/auth:opacity-100 transition-opacity duration-200 ease-out`} data-id="element-80" data-mp="26b8e83oilzil" />
      <span className={`relative flex items-center justify-center w-full overflow-hidden bg-white ${block ? 'py-3.5 rounded-[11px]' : 'px-5 py-2 rounded-full'} text-sm font-semibold text-primary-indigo`} data-id="element-81" data-mp="2l0miwyh5bsrn">
        {/* Whisper of tint in the fill — brightens on hover. */}
        <span aria-hidden className="absolute inset-0 bg-gradient-to-r from-primary-indigo/[0.05] via-ai-purple/[0.07] to-primary-indigo/[0.05] group-hover/auth:from-primary-indigo/[0.09] group-hover/auth:via-ai-purple/[0.12] group-hover/auth:to-primary-indigo/[0.09] transition-colors duration-200 ease-out" data-id="element-82" data-mp="1xascozrc12gd" />
        <span className="relative" data-id="element-83" data-mp="3cu6kq6m1y0xg">Log in / Sign up</span>
      </span>
    </button>;
}